
export default {
  name: "default",
  head() {
    let isInsteFace = this.$route.path.startsWith("/facewow");
    if(isInsteFace) {
      return {
        title: "Facewow",
        link: [
          // hid 需要与 nuxt.config.js 中的一致才能覆盖
          { rel: "icon", type: "image/png", href: "/favicon-facewow.png", hid: "favicon" },
        ]
      }
    }

    let isInstePortraitMe = this.$route.path.startsWith("/portraitme");
    if(isInstePortraitMe) {
      return {
        title: "PortraitMe",
        link: [
          { rel: "icon", type: "image/png", href: "/favicon-portraitme1.png", hid: "favicon" },
        ]
      }
    }
  }
}
